import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, CardContainerV2, GridCard, GridCardPeople } from './styles';
import { Row } from '../PeopleListView/styles';
import { ImageUrl } from '../../utils/constants';
import _ from "lodash";
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ParticipantLocationPopup from '../NewEmployeePopupV2/participantsLocation';
import LazyImage from '../common/LazyImage/LazyImage';
import CommonButton from '../common/CommonButton/CommonButton';

class PeopleGridView extends Component {
  constructor() {
    super();
    this.state = {
      userId: null,
      initiativeId: null,
      initiativeName: null,
      employeeList: [],
      selectedParticipant:[],
      showNote: false,
      onHover: -1
    };
  }

  componentDidMount() {
    const arra = []
    const { employeeList } = this.props;
    employeeList && employeeList.length && employeeList.map((obj) => {
      obj.select = false;
      arra.push(obj)
    })
    this.setState({ employeeList: arra })
    localStorage.setItem("selectedEmployeeList", JSON.stringify([]))
  }

  onHoverMouse = (id) => {
    this.setState({
      onHover: id
    })
  };

  onLeaveHoverMouse = () => {
    this.setState({
      onHover: -1
    })
  };

  onEnterMouse = (uid, id, name) => {
    this.setState({
      userId: uid,
      initiativeId: id,
      initiativeName: name
    })
  };

  onLeaveMouse = () => {
    this.setState({
      userId: null,
      initiativeId: null
    })
  };

  activeTick = (index) => {
    let prev = this.state.employeeList;
    let newData = this.props.employeeList;
    let totalData = prev.concat(newData)
    let objIndex = totalData.findIndex(((obj) => obj.uid == index));
    const prevSelect = totalData[objIndex].select;
    totalData[objIndex].select = !prevSelect;
    let selectedArray = totalData.filter((obj) => obj.select === true)
    let unique = selectedArray.filter((item, index) => selectedArray.indexOf(item) === index);
    this.setState({
      employeeList: totalData,
      selectedParticipant: unique
    });
    localStorage.setItem("selectedEmployeeList", JSON.stringify(selectedArray))
  }

  fallBack = (e) => {
    e.target.src = '/public/images/default.png'
  }

  goToPersonalProfile = (employeeId) => {
    const { history } = this.props;
    history.push(`/company/people/${employeeId}/personal-profile`)
  }

  render() {
    const { 
      showEmployeeDetails, 
      selectedEmployee, 
      sendFriendRequestPost, 
      searchAmigo, 
      t, 
      show, 
      plp, 
      employeeList,
      activeTab,
      showRemoveButton,
      removeButtonId,
      showRemoveButtonHandler,
      openRemoveBuddyPopup
    } = this.props;
    const { userId, initiativeId, initiativeName } = this.state;
    let uidArray = [];
    this.state.selectedParticipant.map((obj) => {
      uidArray.push(obj.uid)
    })
    
    return (
      <Wrapper marginTop={"0px"} content="1">
        {
          !(_.isNull(employeeList)) && !(_.isUndefined(employeeList)) && employeeList.length > 0 ?
            employeeList.map((employee, index) => (
              <CardContainerV2 key={index} marginRight={(index + 1) % 4 === 0 ? "0px" : "25px"} onClick={() => showEmployeeDetails(employee.uid)} active={selectedEmployee === employee.uid} deleted={employee.is_user_deleted && !searchAmigo ? 1 : 0} >
                {searchAmigo?
                  <div style={{ position: 'relative' }}>
                    <GridCard active={selectedEmployee === employee.uid} deleted={employee.is_user_deleted && !searchAmigo}>
                      <div className="wellness-champion">
                        {employee.is_user_deleted && !searchAmigo ? <div>{t("User will be removed end of Month")}</div> : employee.is_champion ? <div>{t("Wellness Champion")}</div> : ""}
                      </div>
                      
                      <div style={{ display: 'flex', width: '100%' }}>
                        <div className="profile">
                          <LazyImage onError={this.fallBack} src={`${ImageUrl}/${employee.profile_image}`}/>
                        </div>
                        <div style={{ width: '20%', }}>
                          {show && <div style={{ width: '24px', height: '24px', border: '1px solid #005C87', borderRadius: '21px',display:"flex",justifyContent:"center",alignItems:"center" }} onClick={() => this.activeTick(employee.uid)} >
                            {uidArray.includes(employee.uid) && <img src={ImageUrl + '/ChallengeDetailsScreen/updatedCheckmark.svg'}></img>}
                          </div>}
                        </div>
                      </div>
                      <div className="name">
                        {t(employee.fname)} {t(employee.fullname)}
                      </div>
                      {employee.department ? <div className="department">
                        {t(employee.department)}
                      </div> :<div className='department'>{""}</div>}
                      <div className="wellness-card">
                        {employee.interests && employee.interests.map((Wellness, index) => (
                          index < 5 &&
                          <div key={index} onMouseEnter={() => this.onEnterMouse(employee.uid, Wellness.interest_id, Wellness.interest_name)} onMouseLeave={() => this.onLeaveMouse()}>
                            <LazyImage src={`${ImageUrl}/${Wellness.interest_icon}`} />
                            {userId === employee.uid && initiativeId === Wellness.interest_id &&
                              <div className="hover-card">
                                <div> {t(initiativeName)}</div>
                              </div>}
                          </div>))}
                      </div>
                      {searchAmigo ?
                        <div className="mutual-buddies">
                          {employee.mutual_friends_details && employee.mutual_friends_details.length > 0 ?
                            <div>
                              <div className="text">{t("Mutual")}</div>
                              <div className="profile-image-card"> 
                                {employee.mutual_friends_details && employee.mutual_friends_details.length > 0 && employee.mutual_friends_details.map((mutual, index) =>
                                  index < 2 &&
                                  <img onError={this.fallBack} src={`${ImageUrl}/${mutual.profile_image}`} key={index} />
                                )}
                                {employee.mutual_friends_details && employee.mutual_friends_details.length > 2 &&
                                  <div className="count">{employee.mutual_friends_details.length - 2}+</div>}
                              </div>
                            </div> :
                            null}
                        </div>
                        :
                        <div className="mutual-buddies">
                          <div>
                            {
                              employee.total_global_points ?
                                <div className='no-text'>
                                  {`${employee.total_global_points} Pts`}
                                </div> :null
                            }
                          </div>
                        </div>
                      }
                      <div className="button-cotainer" style={{marginTop: employee.mutual_friends && employee.mutual_friends.length === 0?"65px":"0"}}>
                        {!searchAmigo ?
                          <CommonButton
                            onClick={() => this.goToPersonalProfile(employee.uid)}
                            btnType={"square"}
                            styles={{background:'#69C2FF', cursor:'pointer'}}
                            title={t("View Profile")}
                          />
                          :
                          employee.friend === 0 ?
                            <CommonButton
                              onClick={() => sendFriendRequestPost(employee.uid)}
                              btnType={"square"}
                              styles={{cursor:'pointer',background:"#fefefe !important",color:'#184A61',border:"1px solid #DA6C74",fontSize:'16px', width:'auto'}}
                              title={t("Add Connection ")}
                              
                            />
                            :
                            employee.friend === 1 ?
                              <CommonButton
                                styles={{background:"rgb(159, 201, 137)", cursor: activeTab === 'connections' ? 'default' : 'pointer'}}
                                btnType={"square"}
                                title={t("Buddies")}
                              />
                              : employee.friend === 2 ?
                                <CommonButton
                                  styles={{background:"rgb(246, 180, 121)"}}
                                  btnType={"square"}
                                  title={t("Pending")}
                                /> 
                                : ""}
                      </div>
                    </GridCard>

                    {/* Menu button for connections tab only */}
                    {activeTab === 'connections' && (
                      <div 
                        style={{ 
                          position: 'absolute', 
                          top: '10px', 
                          right: '10px', 
                          // zIndex: 1000,
                          width: '24px',
                          height: '24px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(255,255,255,0.9)',
                          borderRadius: '50%',
                          cursor: 'pointer'
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          showRemoveButtonHandler && showRemoveButtonHandler(employee.friend_id || employee.uid);
                        }}
                      >
                        <div style={{
                          width: '4px',
                          height: '4px',
                          backgroundColor: '#DA6C74',
                          borderRadius: '50%',
                          position: 'relative'
                        }}>
                          <div style={{
                            position: 'absolute',
                            top: '-6px',
                            left: '0',
                            width: '4px',
                            height: '4px',
                            backgroundColor: '#DA6C74',
                            borderRadius: '50%'
                          }}></div>
                          <div style={{
                            position: 'absolute',
                            top: '6px',
                            left: '0',
                            width: '4px',
                            height: '4px',
                            backgroundColor: '#DA6C74',
                            borderRadius: '50%'
                          }}></div>
                        </div>
                      </div>
                    )}

                    {/* Remove button dropdown */}
                    {showRemoveButton && removeButtonId === (employee.friend_id || employee.uid) && activeTab === 'connections' && (
                      <div style={{
                        position: 'absolute',
                        top: '40px',
                        right: '10px',
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        padding: '8px 12px',
                        cursor: 'pointer',
                        // zIndex: 1001,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        minWidth: '120px',
                        fontSize: '14px',
                        color: '#333'
                      }}>
                        <div 
                          onClick={(e) => {
                            e.stopPropagation();
                            openRemoveBuddyPopup && openRemoveBuddyPopup(employee.fullname || employee.name, employee.friend_id || employee.uid);
                          }}
                          style={{ 
                            padding: '4px 0',
                            borderRadius: '4px',
                            transition: 'background-color 0.2s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                          {t("Remove Buddy")}
                        </div>
                      </div>
                    )}
                  </div>
                  :
                  <GridCardPeople active={selectedEmployee === employee.uid} deleted={employee.is_user_deleted && !searchAmigo}
                    background={"#69C2FF"} cursor={employee.is_user_deleted}
                  >
                    {/* Regular employee view remains the same */}
                  </GridCardPeople>}
              </CardContainerV2>
            ))
            :
            <Row disableCursor={1} align={1} upperBoxShadow="2px solid rgba(0,0,0,0.08)">
              {t("No Employee")}
            </Row>
        }
        {!searchAmigo &&
          <ParticipantLocationPopup companyId={plp.companyId} fetchEditLocationApi={plp.fetchEditLocationApi}
            show={plp.show} departmentData={plp.departmentData} handleShowNote={plp.handleShowNote} data={plp.data} showModalPopUp={plp.showModalPopUp} selectedParticipant={this.state.selectedParticipant} companyAuthDetails={plp.companyAuthDetails}/>
        }
      </Wrapper>)
  }
}

PeopleGridView.propTypes = {
  employeeList: PropTypes.array.isRequired,
  showEmployeeDetails: PropTypes.func.isRequired,
  selectedEmployee: PropTypes.any,
  searchAmigo: PropTypes.bool,
  history: PropTypes.object,
  t: PropTypes.func,
  sendFriendRequestPost: PropTypes.func,
  show: PropTypes.bool,
  plp: PropTypes.object,
  activeTab: PropTypes.string,
  showRemoveButton: PropTypes.bool,
  removeButtonId: PropTypes.any,
  showRemoveButtonHandler: PropTypes.func,
  openRemoveBuddyPopup: PropTypes.func
};

const mapStateToProps = (state) => ({
  sentRequest: state.social.sentRequest
});

export default connect(mapStateToProps, null)(withTranslation()(PeopleGridView));
